export class UndefinedContextError extends Error {}
